import React from 'react'
import Header from "./header"
import Footer from "./footer"

function index({ children }) {
    return (
        <>
            <Header />
            <div className="main">{children}</div>
            <Footer />
        </>

    )
}

export default index